import { default as swal } from 'sweetalert2'

module.exports = {
  success: function (text) {
    swal({
      text: text,
      type: 'success',
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000
    })
  },
  warn: function (text) {
    swal({
      text: text,
      type: 'error',
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000
    })
  },
  confirm: function (text, options) {
    if (!options) options = {}
    return new Promise((resolve, reject) => {
      swal({
        title: 'Are you sure?',
        text: text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Delete',
        closeOnConfirm: false,
        ...options
      }).then(confirmed => {
        resolve(!confirmed.dismiss)
      })
    })
  },
  deleteConfirm: function (text, callback) {
    swal({
      title: 'Are you sure?',
      text: text,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Delete',
      closeOnConfirm: false
    }).then(confirmed => {
      // eslint-disable-next-line
      if (confirmed.dismiss) return callback(false)
      // eslint-disable-next-line
      callback(true)
    })
  },
  alert: function (head, text, type) {
    swal(head, text, type)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/notify.js